import css from "./AddEngineer.module.css"
import AddEnterpriseEngineeerOptions from "./AddEnterpriseEngineerOption"
import { useState } from "react"
import Form from "../Form/Form"
const AddEnterpriseEngineer = ({onSubmit}) => {
  const[options, setOptions]=useState(AddEnterpriseEngineeerOptions);
  const init=()=>{
    const op={...options}
    op.Fields[0].value="";
    setOptions(op);
  }
  const handleSubmit=()=>{
    onSubmit(options);
    init();
  }
  return (
    <div className={css.AddEngineer}>
      <Form onSubmit={handleSubmit}>{options}</Form>
    </div>
  )
}

export default AddEnterpriseEngineer